<script setup lang="ts">
import {HStackVariants, hstackVariants} from "@/shared/components/ui/helper/index.ts";
import {cn} from "@/shared/lib/utils.ts";
import {Primitive} from "radix-vue";
//@ts-ignore
import type { PrimitiveProps } from "radix-vue";
import {HTMLAttributes} from "vue";

interface HStackProps extends PrimitiveProps {
  align?: HStackVariants['align']
  justify?: HStackVariants['justify']
  as?: string
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<HStackProps>(), {
  as: 'div',
})

</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :class="cn(hstackVariants({ justify, align }), props.class)">
    <slot/>
  </Primitive>
</template>

<style scoped>

</style>